import React, { ChangeEvent, ReactElement } from 'react'

import { ReceiptsLeftActions } from './elements/ReceiptsLeftActions'
import { ReceiptsRightActions } from './elements/ReceiptsRightActions'
import * as Styled from './styles'

interface ReceiptsActionsProps {
  hideSelectAll?: boolean
  onSelectAllActionChange: (event: ChangeEvent<HTMLInputElement>) => void
  selectedReceiptsCount: number
}

export const ReceiptsActions = ({
  hideSelectAll = false,
  onSelectAllActionChange,
  selectedReceiptsCount,
}: ReceiptsActionsProps): ReactElement => (
  <Styled.ReceiptsActionsWrapper>
    <ReceiptsLeftActions
      hideSelectAll={hideSelectAll}
      onSelectAllActionChange={onSelectAllActionChange}
      selectedReceiptsCount={selectedReceiptsCount}
    />
    <ReceiptsRightActions />
  </Styled.ReceiptsActionsWrapper>
)
